'use strict';

angular.module('selfAccessRequestControllers')

.controller('ArrivalLocationEquipmentExplanationController',
             ['$scope', '$stateParams', 'topBar', '$modal', '$state', '$timeout', 'selfAccessRequest', 'processStep', 'selfAccessRequestService',
    function ($scope, $stateParams, topBar, $modal, $state, $timeout, selfAccessRequest, processStep, selfAccessRequestService) {

        // Set the header Bar
        topBar.setTitleAndIcon('Self Service Arrival Request &nbsp;<i class="fa fa-chevron-right fa-align"></i>&nbsp; ' +
                               '<i class="' + processStep.CssIcon + '"></i> ' + processStep.StepTitleEN, 'fa-pencil-square-o');
                    
        $scope.selfAccessRequest = selfAccessRequest;

        // $scope.currentUserId = selfAccessRequest.EmployeeID;
        selfAccessRequestService
            .getProcessStepStatusListForSelfAccessRequest(selfAccessRequest.UserAccessRequestID)
            .then(function (processStepStatusList) {
                $scope.processStepStatusList = processStepStatusList;
            });

        // Go to Location
        $scope.goToLocationEquipment = function () {
            $state.go('selfAccessRequest.arrival.locationEquipment', {
                userAccessRequestId: selfAccessRequest.UserAccessRequestID});
        }

        // Go to Next Explanation Step
        $scope.goToNextExplanationStep = function (step) {
            $state.go('selfAccessRequest.arrival.locationEquipmentHelp' + step,
                        { authLogin: $scope.authLogin });
        }
}]);

